import polyglotI18nProvider from 'ra-i18n-polyglot';
import { en } from './en';
import { ru } from './ru';

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === 'ru') return ru;
    return en; // default to English
  },
  'en', // default locale
  [
    { locale: 'en', name: 'English' },
    { locale: 'ru', name: 'Русский' },
  ],
  { allowMissing: true }
);
